import { FC, ReactNode } from 'react';
import style from './index.module.css';

export const NavigationWrapper: FC<{ 
  children: ReactNode,
  useInInformation?: boolean
}> = ({
  children,
  useInInformation = false
}) => {

  const className = useInInformation ? `${style.wrapper} ${style.left}` : style.wrapper;

  return (
    <>
      <div className={className}>
        {children}
      </div>
    </>
  )
}